"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));

var CellText = function CellText(props) {
  var renderValue = props.row[props.col.key];

  if (typeof renderValue === 'string') {
    renderValue = renderValue.trim();

    if (!renderValue.length) {
      renderValue = '--';
    }
  } else if (typeof renderValue === 'number') {
    renderValue = renderValue.toString();
  } else {
    renderValue = '--';
  }

  var tooltip = props.col.tooltipKey && props.row[props.col.tooltipKey] !== undefined ? props.row[props.col.tooltipKey] : renderValue;
  return _react.default.createElement("div", {
    "data-cw-grid-cell-text": true,
    className: _CwDataGrid.default.cell,
    title: tooltip,
    style: {
      width: props.col.width
    }
  }, renderValue);
};

CellText.propTypes = {
  col: _propTypes.default.object.isRequired,
  row: _propTypes.default.object.isRequired
};
var _default = CellText;
exports.default = _default;